// extracted by mini-css-extract-plugin
export var chevron = "product-dropdown-module--chevron--cxGY2";
export var container = "product-dropdown-module--container--iGtxS";
export var dropdown = "product-dropdown-module--dropdown--K7eIu";
export var item = "product-dropdown-module--item--70y17";
export var open = "product-dropdown-module--open--5rTM8";
export var toggleButton = "product-dropdown-module--toggle-button--ZK1cX";